/**
 * @generated SignedSource<<4df9691b6a5d7cf1a6977a765927bcbf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ForumOwnerKind = "BLOG" | "COMPETITION" | "DATASET" | "EVENT" | "TOP_LEVEL" | "WORKSPACE";
import { DateTime } from "@/common/relayCustomScalar";
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type ForumFragment$data = {
  readonly icon: Url | null | undefined;
  readonly owner: {
    readonly forumOwnerKind: ForumOwnerKind;
    readonly slug: string;
  };
  readonly shortDescription: string;
  readonly slug: string;
  readonly title: string;
  readonly topics: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly username: string;
      };
      readonly createdAt: DateTime;
    }>;
  };
  readonly viewerCanEdit: boolean;
  readonly " $fragmentType": "ForumFragment";
};
export type ForumFragment$key = {
  readonly " $data"?: ForumFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ForumFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForumFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forumOwnerKind",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": "NEWEST"
        }
      ],
      "concreteType": "TopicConnection",
      "kind": "LinkedField",
      "name": "topics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "topics(first:1,order:\"NEWEST\")"
    },
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_FORUM"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_FORUM\")"
    }
  ],
  "type": "Forum",
  "abstractKey": null
};
})();

(node as any).hash = "7bbb8a8d851e327a08af5d954a39c3f5";

export default node;
